import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import TextField from '@material-ui/core/TextField';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';

const propTypes = {
  mesicniSplatka: PropTypes.string.isRequired,
  nesplacenajistina: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  prijem: PropTypes.string.isRequired,
  refinancovani: PropTypes.string.isRequired,
  splatka: PropTypes.string.isRequired,
  terminkoncefixace: PropTypes.string.isRequired,
};

export default function ExtendedForm(props) {
  const {
    onChange,
    nesplacenajistina,
    refinancovani,
    prijem,
    splatka,
    terminkoncefixace,
    mesicniSplatka,
  } = props;

  return (
    <React.Fragment>
      <TextField
        id='nesplacenajistina'
        label='Aktuální výše nesplacené jistiny k datu:'
        multiline
        rowsMax='4'
        value={nesplacenajistina}
        onChange={onChange('nesplacenajistina')}
        variant='outlined'
        fullWidth
        margin='dense'
      />
      <TextField
        id='terminkoncefixace'
        label='Termín konce fixace úrokové sazby:'
        value={terminkoncefixace}
        onChange={onChange('terminkoncefixace')}
        variant='outlined'
        fullWidth
        margin='dense'
      />
      <TextField
        id='mesicniSplatka'
        label='Aktuální výše měsíční splátky:'
        value={mesicniSplatka}
        onChange={onChange('mesicniSplatka')}
        variant='outlined'
        fullWidth
        margin='dense'
      />
      <p>Refinancování úvěru poskytnutého na:</p>
      <StyledRadioGroup
        aria-label='refinancovani'
        name='refinancovani'
        value={refinancovani}
        onChange={onChange('refinancovani')}
      >
        <FormControlLabel
          value='rekonstrukce'
          control={<Radio color='primary' />}
          label='Rekonstrukce'
          labelPlacement='start'
        />
        <FormControlLabel
          value='koupe'
          control={<Radio color='primary' />}
          label='Koupě'
          labelPlacement='start'
        />
      </StyledRadioGroup>
      <TextField
        id='prijem'
        label='Měsíční příjem do fondu oprav:'
        value={prijem}
        onChange={onChange('prijem')}
        variant='outlined'
        fullWidth
        margin='dense'
      />
      <TextField
        id='splatka'
        label='Maximální výše měsíční splátky:'
        value={splatka}
        onChange={onChange('splatka')}
        variant='outlined'
        fullWidth
        margin='dense'
      />
    </React.Fragment>
  );
}

ExtendedForm.propTypes = propTypes;

const StyledRadioGroup = styled(RadioGroup)`
  flex-direction: row !important;
  justify-content: space-around;
  align-items: center;
`;
